import { Grid } from "@mui/material";
import type { PropsWithChildren } from "react";

interface Props {
  width?: number | string;
}

const ScrollableColumn = ({ width, children }: PropsWithChildren<Props>) => (
  <Grid size={width ? false : "grow"} sx={{ height: "100%", width, overflowY: "auto" }}>
    {children}
  </Grid>
);

export default ScrollableColumn;
